export default "__VITE_ASSET__CpnjMt$x__"